export class PracticeDelete {
  orden: number
  motivo: string
  clasi: string
}
